var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isColspan)?_c('b-th',{attrs:{"colspan":_vm.field.colspanNum[_vm.level]}},[_vm._v(_vm._s(_vm.field.colspanLabel[_vm.level]))]):_c('b-th')}
var staticRenderFns = []

export { render, staticRenderFns }